module.exports = __webpack_public_path__ + "static/media/hexagon_base_blue_orange.798ffdf6.svg";